<template>
    <div class="social_blocks">
        <a href="https://www.instagram.com/onemglcom/" target="_blank">
            <div class="social_block instagram">
                <div class="social_block_inner">
                    <div class="social_block_icon">
                        <ion-icon name="logo-instagram"></ion-icon>
                    </div>
                    <div class="social_block_content">
                        <h4>Instagram</h4>
                        <p>@onemglcom</p>
                        <a href="https://www.instagram.com/onemglcom/" target="_blank" class="btn green mt-1">Follow</a>
                    </div>
                </div>
                <div v-if="counts.instagram !== 0" class="social_count_info">
                    <div>
                    <h4 class="social_count">{{ counts.instagram }}</h4>
                    <p>Followers</p>
                    </div>
                </div>
            </div>
        </a>
        <a href="https://www.facebook.com/onemglcom" target="_blank">
            <div class="social_block facebook">
                <div class="social_block_inner">
                    <div class="social_block_icon">
                        <ion-icon name="logo-facebook"></ion-icon>
                    </div>
                    <div class="social_block_content">
                        <h4>Facebook</h4>
                        <p>@onemglcom</p>
                        <a href="https://www.facebook.com/onemglcom" target="_blank" class="btn green mt-1">Like</a>
                    </div>
                    <div v-if="counts.facebook !== 0" class="social_count_info">
                        <div>
                        <h4 class="social_count">{{ counts.facebook }}</h4>
                        <p>Likes</p>
                        </div>
                    </div>
                </div>
            </div>
        </a>
        <a href="https://www.youtube.com/channel/UCjyVpUoJtbVBYcOeC58qG3Q" target="_blank">
            <div class="social_block youtube">
                <div class="social_block_inner">
                    <div class="social_block_icon">
                        <ion-icon name="logo-youtube"></ion-icon>
                    </div>
                    <div class="social_block_content">
                        <h4>Youtube</h4>
                        <p>@onemglcom</p>
                        <a href="https://www.youtube.com/channel/UCjyVpUoJtbVBYcOeC58qG3Q" target="_blank" class="btn green mt-1">Subscribe</a>
                    </div>
                    <div v-if="counts.youtube !== 0" class="social_count_info">
                        <div>
                        <h4 class="social_count">{{ counts.youtube }}</h4>
                        <p>Subscribers</p>
                        </div>
                    </div>
                </div>
            </div>
        </a>
    </div>
</template>

<script>
export default {
    name: 'SocialBlocks',

    data(){
        return{
            counts: {
                youtube: 0,
                facebook: 0,
                instagram: 0

            }
        }
    },

    mounted(){
        this.getYoutubeCounts()
        this.getFacebookCounts()
        this.getInstagramCounts()
    },

    methods: {
        async getYoutubeCounts(){
            // Get Youtube Subscribers
            let baseUrl = 'https://www.googleapis.com/youtube/v3'
            let projectId = 'UCjyVpUoJtbVBYcOeC58qG3Q'
            let apiKey = 'AIzaSyBy_rZM9-CxMcgJxGobRo9zTc8N-3eDa_E'
            let path = `/channels?part=snippet,contentDetails,statistics&id=${projectId}&key=${apiKey}`

            await this.$http.get(`${baseUrl}${path}`).then(res => {

                // console.log('Youtube data res: ', res)
                
                if(res.status === 200){
                    if(res.data){
                        if(res.data.items){
                            if(res.data.items.length > 0){
                                this.counts.youtube = res.data.items[0].statistics.subscriberCount
                            }
                        }
                    }
                }

            }).catch(err => {
                // console.log('Error getting youtube data: ', err)
            })
        },
        async getFacebookCounts(){
            
            let baseUrl = 'https://graph.facebook.com/v9.0/'
            let accessToken = 'EAAFPR0wSDzABAIFRCLDlqm9C9Jxl9GHT8kVyanzkoqSD6d0ZCCXZBqWIB93hq9Xefkg2790x7eakhij9ybKOIKfbKOlKBbgLIsgw3XdZAgfZBginHDMRYISzVGUAslZAI1mhDC85HrDKaIAIM7lqlWCLJ2N0kIZCV6uAACm3VEJhFXtfspzLTyQhQPXM8grX7Bw0dGEFZCbPoP0X5JE9FZAZCZAy78m2topJSSZAZCIdZBYftZCpmJVsxzbKO5'
            
            accessToken = '530491014314573|PHcmAh46qVBr209vJ1ddmO9m0l4'
            
            let path = `me/accounts?fields=fan_count&access_token=${accessToken}`

            await this.$http.get(`${baseUrl}${path}`).then(res => {

                // console.log('Facebook data res: ', res)
                
                if(res.status === 200){
                    if(res.data){
                        if(res.data.data){
                            if(res.data.data.length > 0){
                                this.counts.facebook = res.data.data[0].fan_count
                            }
                        }
                    }
                }
            }).catch(err => {
                // console.log('4.1 Facebook data error: ', err)
            })
        },
        async getInstagramCounts(){

            let baseUrl = 'https://graph.facebook.com/v9.0'
            let userId = '17841436370007716'
            let username = 'onemglcom'
            let accessToken = 'EAAFPR0wSDzABACsGCib8PLdKNhTBXVXRTYwJJG0eDmlw8CAgIbb8lxtZBzWl8Lz9r9AYGggvi78ioGQAFEyixxBs4KHEpaRZCkfY1qqayCgbCQEG43lIZC1MKCWoUt5m3TxNMAZARLHcfl5tRzZAwCpiO12vXGkHusTDSFeqwaY21jD5yXS4FHP7U1IOGdia5TMvCcsQpLerrSvXSLeGv'

            let path = `/${userId}?fields=business_discovery.username(${username}),followers_count&access_token=${accessToken}`

            await this.$http.get(`${baseUrl}${path}`).then(res => {

                // console.log('Instagram data res: ', res)
                
                if(res.status === 200){
                    if(res.body){
                        if(res.body.followers_count){
                            this.counts.instagram = res.body.followers_count
                        }
                    }
                }
            }).catch(err => {
                // console.log('4.1 Get instagram error: ', err)
            })
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/SocialBlocks.vue